let containerId = 'ptt-notifications'

function getContainer () {
  let container = document.getElementById(containerId)
  if (!container) {
    container = document.createElement('div')
    container.id = containerId
    container.style.cssText = 'position:fixed;top:10px;right:10px;z-index:100000;display:flex;flex-direction:column;gap:8px;max-width:400px;'
    document.body.appendChild(container)
  }
  return container
}

const TYPE_CLASSES = {
  info: 'alert-info',
  success: 'alert-success',
  warning: 'alert-warning',
  danger: 'alert-danger',
  error: 'alert-danger'
}

function notify ({ type = 'info', title = '', content = '', duration = 5000 } = {}) {
  const container = getContainer()

  const el = document.createElement('div')
  el.className = `alert ${TYPE_CLASSES[type] || TYPE_CLASSES.info} alert-dismissible`
  el.setAttribute('role', 'alert')
  el.style.cssText = 'margin:0;animation:ptt-notif-fade-in .3s ease;position:relative;min-width:250px;box-shadow:0 2px 8px rgba(0,0,0,.15);'

  const closeBtn = document.createElement('button')
  closeBtn.type = 'button'
  closeBtn.className = 'close'
  closeBtn.setAttribute('aria-label', 'Close')
  closeBtn.innerHTML = '<span aria-hidden="true">&times;</span>'
  closeBtn.addEventListener('click', () => dismiss(el))
  el.appendChild(closeBtn)

  if (title) {
    const titleEl = document.createElement('strong')
    titleEl.textContent = title
    el.appendChild(titleEl)
    el.appendChild(document.createTextNode(' '))
  }

  const contentEl = document.createElement('span')
  contentEl.textContent = content
  el.appendChild(contentEl)

  container.appendChild(el)

  if (duration > 0) {
    setTimeout(() => dismiss(el), duration)
  }
}

function dismiss (el) {
  if (!el || !el.parentNode) return
  el.style.opacity = '0'
  el.style.transition = 'opacity .3s ease'
  setTimeout(() => {
    if (el.parentNode) el.parentNode.removeChild(el)
  }, 300)
}

// Inject animation keyframes once
if (typeof document !== 'undefined' && !document.getElementById('ptt-notif-style')) {
  const style = document.createElement('style')
  style.id = 'ptt-notif-style'
  style.textContent = '@keyframes ptt-notif-fade-in{from{opacity:0;transform:translateY(-10px)}to{opacity:1;transform:translateY(0)}}'
  document.head.appendChild(style)
}

export const Notification = {
  notify
}
